<template>
  <v-card class="beez-card">
    <v-toolbar dense card class="elevation-2">
      <v-toolbar-title class="body-2 beez-bold "
        >{{ emailTemplate.name }}
      </v-toolbar-title>
    </v-toolbar>
    <v-progress-linear
      indeterminate
      class="ma-0"
      color="accent"
      height="5"
      :active="emailTemplateUpdating"
    />
    <div class="pa-3">
      <v-text-field
        :outline="$vuetify.dark"
        color="secondary"
        label="Name(Unique)"
        v-model="name"
        :readonly="!editName"
      >
        <template slot="append">
          <template v-if="editName">
            <v-icon @click="resetName">clear</v-icon>
            <v-icon @click="setName">save</v-icon>
          </template>
          <template v-else>
            <v-icon
              v-if="can('EMAIL_TEMPLATE_KEY_EDIT')"
              @click="editName = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-text-field>
      <v-textarea
        :outline="$vuetify.dark"
        color="secondary"
        no-resize
        :row="1"
        label="Description"
        v-model="description"
        :readonly="!editDescription"
      >
        <template slot="append">
          <template v-if="editDescription">
            <v-icon @click="resetDescription">clear</v-icon>
            <v-icon @click="setDescription">save</v-icon>
          </template>
          <template v-else>
            <v-icon
              v-if="can('EMAIL_DESCRIPTION_EDIT')"
              @click="editDescription = true"
              >edit
            </v-icon>
          </template>
        </template>
      </v-textarea>
      <v-card flat :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
        <v-toolbar dense flat class="body-2 beez-bold ">
          Email Template ( {{ toggleCodeMode ? 'Text Mode' : 'Code Mode' }} )
          <v-spacer></v-spacer>
          <!--          <v-btn-->
          <!--            flat-->
          <!--            icon-->
          <!--            :disabled="!can('EMAIL_TEMPLATE_STRING_EDIT')"-->
          <!--            @click="toggleCodeMode = !toggleCodeMode"-->
          <!--          >-->
          <!--            <v-icon>{{ toggleCodeMode ? 'title' : 'code' }}</v-icon>-->
          <!--          </v-btn>-->
          <v-btn
            flat
            icon
            :disabled="!can('EMAIL_TEMPLATE_PREVIEW')"
            @click="togglePreview = !togglePreview"
            :color="togglePreview ? 'secondary' : ''"
          >
            <v-icon>preview</v-icon>
          </v-btn>
          <template v-if="editTemplateString">
            <v-btn
              flat
              icon
              :disabled="!can('EMAIL_TEMPLATE_STRING_EDIT')"
              @click="resetTemplateString"
            >
              <v-icon>clear</v-icon>
            </v-btn>
            <v-btn
              flat
              icon
              :disabled="!can('EMAIL_TEMPLATE_STRING_EDIT')"
              @click="setTemplateString"
            >
              <v-icon>save</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              flat
              icon
              v-if="can('EMAIL_TEMPLATE_STRING_EDIT')"
              @click="editTemplateString = true"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
        </v-toolbar>
        <v-card-text>
          <v-textarea
            auto-grow
            v-if="!toggleCodeMode"
            outline
            color="secondary"
            placeholder="Email Template String (HTML)"
            label="Template String"
            v-model="templateString"
            :readonly="!editTemplateString"
          >
          </v-textarea>
          <v-card v-if="togglePreview">
            <v-card-title class="body-2 beez-bold ">
              Live Preview
            </v-card-title>
            <v-card-text>
              <div v-html="templateString"></div>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  name: 'EmailTemplateDetail',

  props: {
    emailTemplate: Object
  },

  components: {},

  data() {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['image', 'code-block']
      ],
      toggleCodeMode: false,
      togglePreview: false,
      editName: false,
      editDescription: false,
      editTemplateString: false,
      name: this.emailTemplate.name,
      description: this.emailTemplate.description,
      templateString: this.emailTemplate.templateString,
      emailTemplateUpdating: false
    }
  },

  watch: {
    emailTemplate() {
      this.name = this.emailTemplate.name
      this.description = this.emailTemplate.description
      this.templateString = this.emailTemplate.templateString
    }
  },

  computed: {
    ...mapGetters({
      can: 'can'
    })
  },

  methods: {
    async setDescription() {
      this.emailTemplateUpdating = true
      this.editDescription = false
      try {
        await this.$store.dispatch('updateEmailTemplate', {
          body: { description: this.description },
          hexId: this.emailTemplate.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Email Template description updated Successfully',
          description: 'Email template description updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Email Template description update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetDescription()
      }
      this.emailTemplateUpdating = false
    },
    resetDescription() {
      this.editDescription = false
      this.description = this.emailTemplate.description
    },
    async setName() {
      this.emailTemplateUpdating = true
      this.editName = false
      try {
        await this.$store.dispatch('updateEmailTemplate', {
          body: { name: this.name },
          hexId: this.emailTemplate.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Email Template name updated Successfully',
          description: 'Email template name updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Email Template name update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetName()
      }
      this.emailTemplateUpdating = false
    },
    resetName() {
      this.editName = false
      this.name = this.emailTemplate.name
    },
    async setTemplateString() {
      this.emailTemplateUpdating = true
      this.editTemplateString = false
      try {
        await this.$store.dispatch('updateEmailTemplate', {
          body: { templateString: this.templateString },
          hexId: this.emailTemplate.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Email Template string updated Successfully',
          description: 'Email template string updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Email Template string update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetTemplateString()
      }
      this.emailTemplateUpdating = false
    },
    resetTemplateString() {
      this.editTemplateString = false
      this.templateString = this.emailTemplate.templateString
    },
    editForm() {
      this.$router
        .push({
          name: 'email-template-designer',
          params: {
            emailTemplate: this.emailTemplate,
            hexId: this.emailTemplate.hexId
          }
        })
        .catch()
    }
  }
}
</script>

<style scoped></style>
